var m = require('mithril');
var prop = require('mithril/stream')
var key = require('../../libs/keybindings');
var telegraph = require('../../libs/Telegraph');
var downloadFile = require('./downloadFile');
var pageScrollLock = require('./pageScrollLock');

var modal = {};
var releasePageScrollLock = null;
var reportRowCellStyle = { height: '3.25rem', minHeight: '3.25rem' };

function downloadReportFiles(record) {
  var files = record && Array.isArray(record.files) && record.files.length
    ? record.files
    : (record && Array.isArray(record.urls) && record.urls.length
      ? record.urls.map(function (url) { return { url: url }; })
      : [{ url: record && record.url }]);
  return files.filter(function (file) {
    return file && file.url;
  }).reduce(function (promise, file) {
    return promise.then(function () {
      return downloadFile(file.url, file.filename ? { filename: file.filename } : undefined);
    });
  }, Promise.resolve());
}

telegraph(modal);


modal.vm = {
  title: prop(null),
  buttons: prop([]),
  body: 'span',
  opened: prop(false),
  hideCloseIcon:prop(false),
  open: function (options) {
    modal.vm.opened(true);
    if (!releasePageScrollLock) {
      releasePageScrollLock = pageScrollLock.acquire();
    }
    modal.emit('opened');
    key.setScope('modal');
  },
  close : function (arg) {
    modal.vm.opened(false);
    if (releasePageScrollLock) {
      releasePageScrollLock();
      releasePageScrollLock = null;
    }
    key.setScope('home');
    modal.emit('closed');
    modal.vm.hideCloseIcon(false);
    modal.vm.buttons([]);
    modal.vm.body = prop(m('div')); // Trigger onremove for body     
  },
}

key('esc', 'modal', modal.vm.close);


modal.view = function (vnode) {
  return m('div.bg-dark-gray', {style: {display: (modal.vm.opened() ? 'block' : 'none')}}, [
    m('div.fixed.top-0.h-100.w-100', {
      onclick: function(e) {
        if (e.target !== this || modal.vm.hideCloseIcon()) return;
        modal.vm.close();
      },
      style: {
        visibility: (modal.vm.opened() ? 'visible' : 'hidden'),
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999,
        overflowX: 'hidden',
        overflowY: 'auto',
        overscrollBehavior: 'contain'
      }
    }, [
      m('div.bg-black.mt5.mh5.pa4.w-50-l.w-80-m.w-100-ns.center', {zIndex: 1000}, [
        m('i.ion-close.fr', {onclick: modal.vm.close}),
        m('h2.fw3.mb4', 'Download Reports'),
        m('div', {role:'form'}, [
          m('table.w-100.f4.mb4.mt2', [
            m('thead', [
              m('tr', [ 
                m('th.ph0.tl', 'Name'),
                m('th.ph0.tc', 'Status'),
                m('th.ph0.tc', 'Generated'),
                m('th.ph0.tc', 'Actions')
              ])
            ]),
            m('tbody', [
              vnode.attrs.reportsArray().length === 0
                ? m('tr', [m('td.tc.pv3.gray', {
                  colspan: 4,
                  style: reportRowCellStyle
                }, 'No generated reports yet.')])
                : vnode.attrs.reportsArray().map( record => {
                return m('tr',[
                  m('td.tl.ph1.pv2', { style: reportRowCellStyle }, record.name),
                  m('td.tc.ph1.pv2', {
                    style: reportRowCellStyle,
                    title: record.errorMessage || record.progressMessage || ''
                  }, record.status.charAt(0).toUpperCase() + record.status.slice(1)),
                  m('td.tl.ph1.pv2', { style: reportRowCellStyle }, record.timestamp),
                  m('td.tc.pv2', { style: reportRowCellStyle }, [
                    record.status == 'done' ? 
                      m(`i.f1.ion-ios-download.green`, {
                        onclick: () =>{
                          downloadReportFiles(record)
                          .catch(function (err) {
                            record.status = 'error';
                            record.errorMessage = err && err.message ? err.message : 'Download failed';
                            m.redraw();
                          });
                        }
                      }) 
                    : 
                      ''
                  ])
                ])
              })
            ])
          ]),
          
        ])
        
      ])
    ])
  ])
}

module.exports = modal;
